export default "__VITE_ASSET__DVodUkmW__"